import React, {useState} from 'react';
import {useControllerProps} from '../../../ControllerContext';
import {Text, TextButton, TextPriority} from 'wix-ui-tpa/cssVars';
import {ChevronDown, ChevronUp} from '@wix/wix-ui-icons-common/on-stage';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {classes} from './Subscriptions.st.css';
import {TotalsSectionDataHook} from '../TotalsSection';

const VISIBLE_LINES = 2;

export function Subscriptions() {
  const {subscriptionsProjections} = useControllerProps().thankYouPageStore;
  const visibleProjections = subscriptionsProjections.slice(0, VISIBLE_LINES);
  const collapsedProjections = subscriptionsProjections.slice(VISIBLE_LINES);

  if (!subscriptionsProjections.length) {
    return null;
  }

  return (
    <div className={classes.projectionsContainer}>
      {visibleProjections.map((projection, i) => (
        <Text
          key={i}
          data-hook={TotalsSectionDataHook.subscriptionProjection}
          priority={TextPriority.secondary}
          className={classes.projectionText}>
          {projection}
        </Text>
      ))}
      {!!collapsedProjections.length && (
        <Collapse>
          {collapsedProjections.map((projection, i) => (
            <Text
              key={i}
              data-hook={TotalsSectionDataHook.subscriptionProjection}
              priority={TextPriority.secondary}
              className={classes.projectionText}>
              {projection}
            </Text>
          ))}
        </Collapse>
      )}
    </div>
  );
}

function Collapse({children}: {children: React.ReactNode}) {
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const chevron = isOpen ? <ChevronUp /> : <ChevronDown />;
  const toggleText = isOpen
    ? t('thankYouPage.totals.subscriptions.showLess')
    : t('thankYouPage.totals.subscriptions.showMore');

  return (
    <>
      {isOpen && <div>{children}</div>}
      <TextButton
        onClick={() => setIsOpen(!isOpen)}
        className={classes.projectionText}
        data-hook={TotalsSectionDataHook.subscriptionProjectionToggle}>
        <div className={classes.toggleButton}>
          {toggleText}
          {chevron}
        </div>
      </TextButton>
    </>
  );
}
